import React, { useState, useEffect } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { AppBar } from "@mui/material";
import Header, {
  NavLink,
  LogoLink,
  NavToggle,
  DesktopNavLinks,
} from "../headers/light.js";

// Styled Components
const AppBarStyled = styled(AppBar)`
  ${tw`transition-all duration-300 bg-white shadow-lg`};
  z-index: 9999; /* Ensure the header has the highest z-index */
  position: fixed; /* Ensure it's fixed at the top */
  transform: ${(props) =>
    props.isVisible ? "translateY(0)" : "translateY(-100%)"};
`;

const StyledHeader = styled(Header)`
  ${tw`pt-6 md:pt-8`}

  ${DesktopNavLinks} ${NavLink}, ${LogoLink} {
    ${tw`text-gray-100 hover:border-gray-300 hover:text-gray-300`}
  }

  ${NavToggle}.closed {
    ${tw`text-gray-100 hover:text-primary-500`}
  }
`;

const Container = styled.div`
  ${tw`relative -mx-8 -mt-8 bg-center bg-cover`};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #0c4d96;
  @media (max-width: 768px) {
    background-size: contain; /* Ensures the image fits within the container on smaller screens */
  }
`;

const HeroContainer = tw.div`z-20 relative pt-2 px-8 sm:px-12 max-w-screen-xl mx-auto`;

export default ({ navLinks }) => {
  const pathName = window.location.pathname;
  const [isVisible, setIsVisible] = useState(pathName !== "/");

  // Scroll logic for showing/hiding header
  const controlHeader = () => {
    if (window.scrollY > 100) {
      setIsVisible(true); // Always show header when scrolling down
    } else {
      setIsVisible(pathName !== "/"); // Show header only if not on root page
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", controlHeader);
    return () => window.removeEventListener("scroll", controlHeader);
  }, [pathName]);

  return (
    <AppBarStyled position="fixed" isVisible={isVisible}>
      <Container>
        <HeroContainer>
          <StyledHeader links={navLinks} />
        </HeroContainer>
      </Container>
    </AppBarStyled>
  );
};
